import { Tag } from 'antd'
import React from 'react'

export default function ComingSoonTag(props) {
    return (
        <Tag {...props}>
            Coming soon!
        </Tag>
    )
}